import React, {useEffect} from "react";
import PropTypes from "prop-types";
import BreadcrumbList from "../../shared/breadcrumb-list";
import { appUrl } from "../../../constants/url-constants";
import CarServiceHistoryBanner from "../car-service-history-banner";
import CarServiceHistoryBenefits from "../../shared/car-service-history-benefits";
import CarServiceHistorySteps from "../../shared/car-service-history-steps";
import CarServiceHistoryRisks from "../car-service-history-risks";
import CarServiceHistoryTestimonials from "../car-service-history-testimonials";
import CarServiceHistoryFaqs from "../car-service-history-faqs";
import CarServiceHistoryMetaTags from "../../shared/car-service-history-meta-tags";
import styles from "./styles.css";
import { NUMBER } from "../../../constants/app-constants";
import { sendCustomGaEvents } from "../../../tracking";
import useC2bCleverTap from "../../../hooks/use-c2b-clevertap";

const CarServiceHistory = ({
    setIsSsrConnect,
    updateSSRStatusConnect,
    gaSource,
    setGaSourceConnect
}) => {
    useC2bCleverTap("Vehicle_history");

    const { source = "" } = gaSource || {};

    useEffect(() => {
        setIsSsrConnect(false);
        updateSSRStatusConnect(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (source) {
            sendCustomGaEvents({us_vas_page_source: source});
            setGaSourceConnect(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source]);

    const onBreadcrumbClick = ({ item }) => {
        if (item === "home") {
            window.location.href = `${appUrl()}/`;
        } else {
            window.location.href = `${appUrl()}${item.redirectURL}`;
        }
    };

    const computeBreadcrumbList = () => {
        const list = [{
            displayText: `Vehicle History`,
            redirectURL: "/car-service-history/"
        }];
        return list;
    };

    return (
        <React.Fragment>
            <CarServiceHistoryMetaTags/>
            <CarServiceHistoryBanner/>
            <div styleName={"styles.mainWrapper"}>
                <CarServiceHistoryRisks isDesktop={true}/>
                <div styleName={"styles.carServiceHistoryBenefits"}>
                    <CarServiceHistoryBenefits/>
                </div>
            </div>
            <div styleName={"styles.carServiceHistoryStepsWrapper"}>
                <CarServiceHistorySteps/>
            </div>
            <CarServiceHistoryTestimonials slidesToShow={NUMBER.FOUR} slug={"car_service_history"} />
            <div styleName={"styles.faqMainWrapper"}>
                <CarServiceHistoryFaqs />
            </div>
            <BreadcrumbList
                homeText={"Home"}
                onClickCallback={onBreadcrumbClick}
                list={computeBreadcrumbList()}
                isRevamped = {true}
                attachSchema={true}
            />
        </React.Fragment>
    );
};

CarServiceHistory.propTypes = {
    setIsSsrConnect: PropTypes.func,
    updateSSRStatusConnect: PropTypes.func,
    gaSource: PropTypes.object,
    setGaSourceConnect: PropTypes.func
};

export default CarServiceHistory;

